import { post , get } from '../http' ;
const comment = {
    listData:params =>post('/app/comment/list.json',params),
    send:params => post('/app/comment/post.json',params),
    reply:params => post('/app/comment/reply.json',params),
    dolike:params => post('/app/praise/post_and_comment.json',params),
    //获取评论数并且获取录播结束状态
    getDiscuss:params => post('/app/live/getRecordStatus.json',params),
    //获取用户头像、信息
    getuserInfo:params => post('/app/user/get_info.json',params),
    getwxuserInfo:params => post('/app/user/wx/get_info.json',params),
    getTestPaper:params => post('/app/examina/findLiveExamina.json',params),
    getlivecommentSwitch:params => post('/app/live/iscomment',params),
    // 用户-获取用户实名认证信息
    getRealNameInfo:params => post('/app/user/auth/realname/info.json',params),
    // 通用-获取需要身份认证的功能列表
    getFunctionsReal:() => post('/app/common/functions/real.json'),
}
export default comment;


// WEBPACK FOOTER //
// ./src/cmtapp/request/api/comment.js